import { Action } from '@ngrx/store';
import { FilterModel } from '../../models';

export const UPDATE_FILTER = '[Filter] Update';
export const UPDATE_COUNTRY_FILTER = '[Filter] Update country';
export const UPDATE_TYPES_FILTER = '[Filter] Update types';
export const TOGGLE_FILTER_TYPE = '[Filter] Update types';
export class UpdateFilter implements Action {
    readonly type = UPDATE_FILTER;
    constructor(public filter: FilterModel) { }
}

export class UpdateCountry implements Action {
  readonly type = UPDATE_COUNTRY_FILTER;
  constructor(public country: string) { }
}

export class ToggleType implements Action {
  readonly type = TOGGLE_FILTER_TYPE;
  constructor(public toggledType: string) { }
}

export type All = UpdateFilter | UpdateCountry | ToggleType;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/actions/filter.actions.ts